// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1NA5m","title":"ClientReferral_title__1Inq6","itemText":"ClientReferral_itemText__2sAhf"};